import { DateGap } from '@fabric-ui/utils';
import { DATE_BUCKET_OPTIONS } from '../../hooks';

export const DATE_BUCKET_OPTIONS_ARR = [
  DATE_BUCKET_OPTIONS.none,
  DATE_BUCKET_OPTIONS.day,
  DATE_BUCKET_OPTIONS.week,
  DATE_BUCKET_OPTIONS.month,
  DATE_BUCKET_OPTIONS.year,
];

export const DATE_BUCKET_TO_DATE_GAP = {
  [DATE_BUCKET_OPTIONS.day.value]: DateGap.Day,
  [DATE_BUCKET_OPTIONS.week.value]: DateGap.Week,
  [DATE_BUCKET_OPTIONS.month.value]: DateGap.Month,
  [DATE_BUCKET_OPTIONS.year.value]: DateGap.Year,
};

export const EXPLODE_OPTION = { title: 'Split - Single Value', value: 'explode' };
export const NOT_EXPLODE_OPTION = { title: 'Grouped - Multi Value', value: 'none' };
export const EXPLODE_OPTIONS = [NOT_EXPLODE_OPTION, EXPLODE_OPTION];
